/** Dispatched on `window` to open the BIR/NPC seal modal (e.g. from footer). */
export const OPEN_BIR_SEAL_BADGE_EVENT = 'abrasoft:openBirSealBadge';
